<template>
    <div>
        <div v-if="label || subLabel">
            <label v-if="label" class="text-sm font-semibold text-gray-900">
                {{ label }}
                <TranslateText :text="labelTrans"/>
            </label>
            <p v-if="subLabel" class="text-sm text-gray-500" v-text="subLabel"/>
        </div>
        <fieldset class="mt-2" :class="{
            'ml-auto flex flex-row': horizontal
        }">
            <div
                class="sm:space-y-0"
                :class="{
                    'space-y-4  sm:flex sm:items-center sm:space-x-5': !horizontal,
                    'flex items-center space-x-5': horizontal,
                }"
            >
                <div v-for="option in options" :key="option.value" class="flex items-center">
                    <input
                        :id="`radio-${uid}-${option.value}`"
                        type="radio"
                        :checked="option.value === modelValue"
                        class="h-4 w-4 border-gray-300 text-green-500 focus:ring-green-500"
                        @change="$emit('update:modelValue', option.value)"
                    />
                    <label
                        :for="`radio-${uid}-${option.value}`"
                        class="ml-2 block text-sm font-medium leading-6 text-gray-900"
                        v-text="option.text"
                    />

                    <TranslateText :text="option.trans" class="ml-1"/>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script setup>
import { v4 as uuidv4 } from 'uuid';
import TranslateText from "@/components/TranslateText.vue";
const uid = uuidv4();

const props = defineProps({
    modelValue: [String, Number],
    label: String,
    labelTrans: String,
    subLabel: String,
    horizontal: Boolean,
    options: Array
})
</script>
